import React from 'react'
import { bikeServiceObjArr } from '../../bin/bikeServiceObjArr/bikeServiceObjArr';
import "./Cards.css";
import { TiTick } from "react-icons/ti";
import { Link } from 'react-router-dom';





export const Cards = ({number, title, showprice, plusmore,Links}) => {
   
    return (

        <div className="card" key={title+number}>
          <div className="card-body" key={title}> 
          <ul className="list-container"key={title+"123"}>
           <h2 className="card-title"key={title+"yolo"} >{title}</h2>
           {/* <p className="content">content</p> */}



           
           {bikeServiceObjArr.map((bikepart, index)=>{
            return index > 2 && index < number ?(
                
            <li key={index} className="card__list-item">
                <b className="tick">{showprice ? bikepart.price :<TiTick/>}</b><i className="service">{bikepart.bikePart}</i>
            </li>
            ) : <React.Fragment key={index}></React.Fragment>

           })}
            <li key={title+"isstrtingkey"} className="card__list-item" style={{fontWeight:"bolder"}} > {plusmore}</li>
            </ul>
           </div> 
           <Link
            to={Links} key={title+"123"} style={{
                display:!showprice?"inline-block":"none",
                width:"100%",
                marginTop:"10px"}}>
               <button className="card-button">Find out more</button>
            </Link>
        </div>
    )
}
